<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="12" md="8">
        <v-subheader>Research Tools</v-subheader>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="tool in r_and_d_tools"
            :key="tool.id"
          >
            <v-expansion-panel-header>
              <v-row no-gutters>
                <v-col sm="2" align-self="center">
                  <div class="d-flex justify-center">
                    <v-btn
                      class="ma-1"
                      block
                      text
                      outlined
                      rounded
                      :to="{ name: 'ToolProcessView', params: { name: tool.name } }"
                    >
                      <v-icon left small>fas fa-cog</v-icon>
                      {{ tool.name }}
                    </v-btn>
                  </div>
                  <div class="d-flex justify-center">
                    <ToolStateChip :tool="tool" />
                  </div>
                </v-col>
                <v-col sm="2">
                </v-col>
                <v-col sm="4">
                  <ToolProcessActiveList :toolid="tool.id" :detailed="false" />
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <v-col sm="12" md="6">
                  <ToolProcessInQueList :toolid="tool.id" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col sm="12" md="8">
        <v-subheader>Production Tools</v-subheader>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="tool in prod_tools"
            :key="tool.id"
          >
            <v-expansion-panel-header>
              <v-row no-gutters>
                <v-col sm="2" align-self="center">
                  <div class="d-flex justify-center">
                    <v-btn
                      class="ma-1"
                      block
                      text
                      outlined
                      rounded
                      :to="{ name: 'ToolProcessView', params: { name: tool.name } }"
                    >
                      <v-icon left small>fas fa-cog</v-icon>
                      {{ tool.name }}
                    </v-btn>
                  </div>
                  <div class="d-flex justify-center">
                    <ToolStateChip :tool="tool" />
                  </div>
                </v-col>
                <v-col sm="2">
                </v-col>
                <v-col sm="4">
                  <ToolProcessActiveList :toolid="tool.id" :detailed="false" />
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <v-col sm="12" md="6">
                  <ToolProcessInQueList :toolid="tool.id" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Tool from "../../models/Tool";
import ToolProcessActiveList from "../../components/Systems/ToolProcessActiveList";
import ToolProcessInQueList from "../../components/Systems/ToolProcessInQueList";
import ToolStateChip from "../../components/Systems/ToolStateChip";
export default {
  name: "Tools",
  components: { ToolStateChip, ToolProcessActiveList, ToolProcessInQueList },
  data() {
    return {
      loading: true,
      search: ""
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    r_and_d_tools() {
      return Tool.query()
        .where("archived", false)
        .with("state")
        .where("r_and_d", true)
        .get();
    },
    prod_tools() {
      return Tool.query()
        .where("archived", false)
        .with("state")
        .where("r_and_d", false)
        .get();
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Tool
        .$fetch()
        .then(() => this.loading = false)
    }
  }
};
</script>
